<template>
    <div class="stateView">
      <div>
        <img :src="imageUrl"/>
        <div>{{ title }}</div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: () => ''
    },
    title: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="sass">
.stateView
  box-sizing: border-box
  padding: 15px
  display: flex
  align-items: center
  justify-content: center
  text-align: center
  color: #cccccc

  img
    width: 120px
    height: 120px
</style>
